"use strict";
module.exports = {
    entityModel: 'customerSubUnitInPCSService',
    events: {
        CUSTOMER_SUB_UNIT_IN_PCS_SERVICE_CREATED: 'CUSTOMER_SUB_UNIT_IN_PCS_SERVICE_CREATED',
        CUSTOMER_SUB_UNIT_IN_PCS_SERVICE_UPDATED: 'CUSTOMER_SUB_UNIT_IN_PCS_SERVICE_UPDATED',
    },
    actions: {
        get: 'v1.customerSubUnitInPCSService.get',
        list: 'v1.customerSubUnitInPCSService.list',
        upsert: 'v1.customerSubUnitInPCSService.upsert',
        upsertWhenEmpty: 'v1.customerSubUnitInPCSService.upsertWhenEmpty',
        updateWhenEmpty: 'v1.customerSubUnitInPCSService.updateWhenEmpty',
        update: 'v1.customerSubUnitInPCSService.update',
    },
    customerTypes: {
        horeca: 'horeca',
        dvh: 'dvh',
        wholesale: 'wholesale',
        office: 'office',
        systembolaget: 'systembolaget',
        supplier: 'supplier',
        export: 'export',
        other: 'other',
    },
    deliveryCountries: {
        SE: 'SE',
        FI: 'FI',
        NO: 'NO',
        DK: 'DK',
        IS: 'IS',
    },
    deliveryCounties: {
        'SE-O': 'SE-O',
        'SE-N': 'SE-N',
        'SE-M': 'SE-M',
        'SE-K': 'SE-K',
        'SE-I': 'SE-I',
        'SE-H': 'SE-H',
        'SE-G': 'SE-G',
        'SE-F': 'SE-F',
        'SE-E': 'SE-E',
        'SE-D': 'SE-D',
        'SE-C': 'SE-C',
        'SE-Z': 'SE-Z',
        'SE-Y': 'SE-Y',
        'SE-X': 'SE-X',
        'SE-W': 'SE-W',
        'SE-BD': 'SE-BD',
        'SE-T': 'SE-T',
        'SE-S': 'SE-S',
        'SE-U': 'SE-U',
        'SE-AC': 'SE-AC',
        'SE-AB': 'SE-AB',
    },
};
